import { Reveal, ChapterLabel } from "./Reveal";

export const Intro = () => (
  <section data-testid="intro-section" className="bg-cream py-24 lg:py-36">
    <div className="max-w-7xl mx-auto px-6 lg:px-10 grid lg:grid-cols-12 gap-12">
      <div className="lg:col-span-5">
        <Reveal>
          <ChapterLabel number="01" title="The Vision" />
          <h2 className="font-serif text-4xl sm:text-5xl text-forest leading-[1.05] tracking-tight">
            Find the Right Homesite for <span className="italic text-brass">Your Vision</span>
          </h2>
        </Reveal>
      </div>
      <div className="lg:col-span-6 lg:col-start-7 flex flex-col gap-6 lg:pt-16">
        <Reveal delay={0.1}>
          <p className="font-sans text-base sm:text-lg leading-relaxed text-muted-foreground">
            Woodlake Estates offers the character of an established residential community with the opportunity to
            build a new custom home. The available properties include a variety of lot sizes and locations, giving
            buyers several options when selecting a homesite that fits their plans.
          </p>
        </Reveal>
        <Reveal delay={0.2}>
          <p className="font-sans text-base sm:text-lg leading-relaxed text-muted-foreground">
            Whether you are looking for a larger property, a quieter cul-de-sac setting, a corner lot or a traditional
            street-front homesite, Woodlake Estates provides a rare opportunity to build in a well-established
            neighborhood.
          </p>
        </Reveal>
      </div>
    </div>
  </section>
);
